import { useState, useEffect } from "react";
import "./ThinkingBubble.css";

// Rotating status words shown while the bot reply is pending, cycled quickly to
// signal active work (à la Claude). Tuned for a recruiting assistant.
const THINKING_WORDS = [
  "Thinking",
  "Analyzing",
  "Reviewing",
  "Cross-referencing",
  "Evaluating",
  "Connecting the dots",
  "Crunching",
  "Working",
];

const ROTATE_MS = 1500;

// Chat loading indicator: a speech bubble with a rotating status word and three
// animated dots. Replaces the standalone Lottie loader so the label and dots
// live inside a single bubble.
const ThinkingBubble = () => {
  const [wordIdx, setWordIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setWordIdx((prev) => (prev + 1) % THINKING_WORDS.length);
    }, ROTATE_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="thinking-bubble">
      <span key={wordIdx} className="thinking-bubble__label">
        {THINKING_WORDS[wordIdx]}
      </span>
      <span className="thinking-bubble__dots" aria-hidden="true">
        <span className="thinking-bubble__dot" />
        <span className="thinking-bubble__dot" />
        <span className="thinking-bubble__dot" />
      </span>
    </div>
  );
};

export default ThinkingBubble;
